// loginRegisterConstants.js
'use strict';

export const Entry = {
  LOGIN: 'login',
  REGISTER: 'register',
};

export const AuthId = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  GOOGLE: 'google-oauth2',
  APPLE_ID: 'apple-id',
  PASSWORD: 'password',
  EMAIL: 'email',
  SMS: 'sms',
  DISCORD: 'discord',
  EMAIL_UNVERIFIED: 'email-unverified',
  WEB_AUTHN: 'webauthn',
};
